// extracted by mini-css-extract-plugin
export default {"logo-container":"Footer_logo-container__BW5vW"};